import { render, staticRenderFns } from "./AgregarSaldoDeudor.vue?vue&type=template&id=cbc6e8de"
import script from "./AgregarSaldoDeudor.vue?vue&type=script&lang=js"
export * from "./AgregarSaldoDeudor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports